import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import { queryClient } from '@/lib/utils/queryClient';
import { CreateGroupDialog } from '../-components/CreateGroupDialog';
import { DeleteGroupDialog } from '../-components/DeleteGroupDialog';
import { EditNameDialog } from '../-components/EditNameDialog';
import { ProductDataPointsView } from '../-components/ProductDataPointsView';
import { productDataPointLayoutQueryOptions } from '../-hooks/useProductDataPointLayout';
import { useProductDataPointsPage } from '../-hooks/useProductDataPointsPage';

export const Route = createFileRoute(
  '/management/product-data-points/(pages)/',
)({
  // A prefetch: rejecting would hide the page's own "Could not load" banner.
  loader: () =>
    queryClient
      .ensureQueryData(productDataPointLayoutQueryOptions)
      .catch(() => undefined),
  component: ProductDataPointsPage,
});

function ProductDataPointsPage() {
  const page = useProductDataPointsPage();

  return (
    <PageContainer>
      <ProductDataPointsView page={page} />
      <CreateGroupDialog page={page} />
      <EditNameDialog names={page.names} />
      <DeleteGroupDialog
        name={page.deleting ? page.nameOf(page.deleting.nameKey) : null}
        onCancel={page.cancelDelete}
        onConfirm={() => void page.confirmDelete()}
        isPending={page.layout.isPending}
      />
    </PageContainer>
  );
}
